import { Component, OnInit } from "@angular/core";

@Component({
  selector: "translate-loader",
  templateUrl: "./translate-loader.component.html",
  styleUrls: ["./translate-loader.component.scss"],
})
export class TranslateLoaderComponent implements OnInit {
  // PROPS
  isTranslateLoaded = false
  constructor() {}

  ngOnInit() {
    setTimeout(()=>{
      this.isTranslateLoaded = true
    }, 500)
  }
}
